export * from './baMenu.component';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baMenu/index.ts